export const modules = {
    toolbar: [
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'size': ['large', 'small', 'huge'] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'line-height': ['1.0', '1.2', '1.5', '1.8', '2.0', '2.5', '3.0'] }],
        [{
            'color': [
                // === Greens (15 shades) ===
                '#f0fff4', '#dcffe4', '#b2f0ab',
                '#9ae6b4', '#84e19e', '#68d391', '#4fd382', '#48bb78',
                '#38a169', '#2f855a', '#276749', '#22543d', '#1a4531',

                // === Blues (15 shades) ===
                '#ebf8ff', '#bee3f8', '#90cdf4',
                '#7bc4f2', '#63b3ed', '#4da6ed', '#4299e1', '#3b82f6',
                '#3182ce', '#2563eb', '#2b6cb0', '#1e40af', '#1a365d',

                // === Reds (15 shades) ===
                '#fff5f5', '#fed7d7', '#feb2b2',
                '#fc8181', '#f56565', '#ef4444', '#e53e3e', '#dc2626',
                '#c53030', '#b91c1c', '#9b2c2c', '#7f1d1d', '#521414',

                // === Purples (15 shades) ===
                '#faf5ff', '#e9d8fd', '#c4b5fd',
                '#b794f4', '#a78bfa', '#9f7aea', '#8b5cf6', '#805ad5',
                '#6b46c1', '#6d28d9', '#553c9a', '#4c1d95', '#322659',

                // === Yellows/Oranges (15 shades) ===
                '#fffff0', '#fefcbf', '#faf089',
                '#f6e05e', '#ecc94b', '#eab308', '#d69e2e', '#ca8a04',
                '#b7791f', '#a16207', '#975a16', '#854d0e', '#5F370E',

                // === Teals (15 shades) ===
                '#e6fffa', '#81e6d9', '#38b2ac',
                '#319795', '#2c7a7b', '#285e61', '#234e52', '#1d4044',
                '#1a3c3d', '#153e3a', '#134e4a', '#0f5555', '#0d4d4d',

                // === Pinks (15 shades) ===
                '#fff5f7', '#fbb6ce', '#ed64a6',
                '#d53f8c', '#b83280', '#97266d', '#702459', '#521b41',
                '#431a3e', '#3b1c38', '#321a32', '#2a1a2c', '#1f1a25',

                // === Grays (15 shades) ===
                '#f7fafc', '#e2e8f0', '#cbd5e0',
                '#a0aec0', '#94a3b8', '#718096', '#64748b', '#4a5568',
                '#3f4a5c', '#374151', '#2d3748', '#1e293b', '#171923'
            ],

        }],
        [{
            'background': [
                // === Greens (15 shades) ===
                '#f0fff4', '#dcffe4', '#b2f0ab',
                '#9ae6b4', '#84e19e', '#68d391', '#4fd382', '#48bb78',
                '#38a169', '#2f855a', '#276749', '#22543d', '#1a4531',

                // === Blues (15 shades) ===
                '#ebf8ff', '#bee3f8', '#90cdf4',
                '#7bc4f2', '#63b3ed', '#4da6ed', '#4299e1', '#3b82f6',
                '#3182ce', '#2563eb', '#2b6cb0', '#1e40af', '#1a365d',

                // === Reds (15 shades) ===
                '#fff5f5', '#fed7d7', '#feb2b2',
                '#fc8181', '#f56565', '#ef4444', '#e53e3e', '#dc2626',
                '#c53030', '#b91c1c', '#9b2c2c', '#7f1d1d', '#521414',

                // === Purples (15 shades) ===
                '#faf5ff', '#e9d8fd', '#c4b5fd',
                '#b794f4', '#a78bfa', '#9f7aea', '#8b5cf6', '#805ad5',
                '#6b46c1', '#6d28d9', '#553c9a', '#4c1d95', '#322659',

                // === Yellows/Oranges (15 shades) ===
                '#fffff0', '#fefcbf', '#faf089',
                '#f6e05e', '#ecc94b', '#eab308', '#d69e2e', '#ca8a04',
                '#b7791f', '#a16207', '#975a16', '#854d0e', '#5F370E',

                // === Teals (15 shades) ===
                '#e6fffa', '#81e6d9', '#38b2ac',
                '#319795', '#2c7a7b', '#285e61', '#234e52', '#1d4044',
                '#1a3c3d', '#153e3a', '#134e4a', '#0f5555', '#0d4d4d',

                // === Pinks (15 shades) ===
                '#fff5f7', '#fbb6ce', '#ed64a6',
                '#d53f8c', '#b83280', '#97266d', '#702459', '#521b41',
                '#431a3e', '#3b1c38', '#321a32', '#2a1a2c', '#1f1a25',

                // === Grays (15 shades) ===
                '#ffff', '#e2e8f0', '#cbd5e0',
                '#a0aec0', '#94a3b8', '#718096', '#64748b', '#4a5568',
                '#3f4a5c', '#374151', '#2d3748', '#1e293b', '#171923'
            ],
        }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        ['link', 'image'],
        ['clean']
    ]
};
